import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { restoreOriginalTitle, setTranslatedTitle } from "./pageTitle";

// Only acts in English. Bosnian pages keep whatever title they have today.
export function usePageTitle(key) {
	const { t, i18n } = useTranslation();
	const language = i18n.resolvedLanguage;

	useEffect(() => {
		if (language === "en") setTranslatedTitle(document, t(key));
		else restoreOriginalTitle(document);
	}, [key, language, t]);
}
